import { TbCherryFilled } from "react-icons/tb";
import { ImSun } from "react-icons/im";
import { LuFolderSync } from "react-icons/lu";
import { IoLibrary } from "react-icons/io5";
import { FaCalendarCheck } from "react-icons/fa6";

export const LuCherryIcon = (props) => <TbCherryFilled size={"22"} />;
export const WeatherIcon = (props) => <ImSun size={"22"} />;
export const LuFolderSyncIcon = (props) => <LuFolderSync size={"22"} />;
export const AuditLibraryIcon = (props) => <IoLibrary size={"20"} />;
export const FaCalendarCheckIcon = (props) => <FaCalendarCheck size={"20"} />;
